export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 border-b border-border bg-white px-6 py-5">
      <div>
        <h1 className="font-head text-2xl font-extrabold text-[#234E7D]">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
